/**
 * Owns the one question MahiIntro cannot answer about itself: has this person
 * already been shown the wordmark animation in this session?
 *
 * Session-scoped on purpose, and that scope is the whole design constraint.
 * A once-ever splash can afford to hold a beat and make a point; something
 * that replays every time a tab is opened cannot, because its real audience
 * is the returning user who has seen it fifty times. That is why the intro is
 * ~1.2s of app-opening rather than a title card, and why this lives in
 * sessionStorage rather than localStorage or a server flag.
 *
 * Deliberately not the same gate as the Discover tour (useDiscoverTour), which
 * is once-per-account and server-backed: the tour teaches the screen, this
 * introduces the brand, and they are shown to different people at different
 * cadences. They do have to be sequenced — see DiscoveryFeed's `introPending`.
 */
const KEY = 'mahi_intro_played';

// Fallback for private-mode/storage-blocked browsers, where sessionStorage
// throws on both read and write. A module-level flag still stops the intro
// replaying on every in-app navigation to /discover, which is the failure that
// would actually be noticed; it resets on reload, so those users see it once
// per page load instead of once per session. Better than the alternatives:
// suppressing it entirely, or replaying it on every mount.
let playedThisLoad = false;

export function shouldPlayMahiIntro() {
  if (playedThisLoad) return false;
  try {
    return sessionStorage.getItem(KEY) !== '1';
  } catch {
    return true;
  }
}

export function markMahiIntroPlayed() {
  playedThisLoad = true;
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* the in-memory flag above is the whole fallback */
  }
}
